module.exports = __webpack_public_path__ + "img/photo-18.fa0d0219.webp";